import { produce } from 'immer'

import {
  initialPlaybookBody,
  initialPlaybookWarningsBody,
} from '@/views/Playbooks/playbook.helpers'

import {
  add,
  edit,
  remove,
  lock,
  win,
  reorder,
  reorderAndMove,
  addChecklistVariations,
  addChecklistItemVariations,
  getAllCategoryIDs,
  addChecklistCategory,
  removeChecklistCategory,
  renameChecklistCategory,
  reorderChecklistCategories,
  moveChecklistItem,
} from './playbook.helpers'

// Action Types
export const SET_LOADING = 'playbooks/setLoading'
export const SET_PLAYBOOK = 'playbooks/setPlaybook'
export const SET_PLAYBOOK_WARNINGS = 'playbooks/setPlaybookWarnings'
export const SET_PLAYBOOK_SECTION_WARNINGS = 'playbooks/setPlaybookSectionWarnings'
export const SET_PLAYBOOK_ENTRY_WARNINGS = 'playbooks/setPlaybookEntryWarnings'
export const SET_CHECKLIST_VARIATIONS = 'playbooks/setChecklistVariations'
export const SET_NOVEL_CHECKLIST_ITEMS = 'playbooks/setNovelChecklistItems'
export const TOGGLE_NOVEL_CHECKLIST_VISIBLE = 'playbooks/toggleNovelChecklistItems'
export const SET_CHECKLIST_ITEM_VARIATIONS = 'playbooks/setChecklistItemVariations'
export const SET_VALIDATION_ERROR = 'playbooks/setValidationError'
export const CLEAR_VALIDATION_ERROR = 'playbooks/clearValidationError'
export const SET_PLAYBOOK_VERSIONS = 'playbooks/setVersions'
export const ACTIVATE_PLAYBOOK_VERSION = 'playbooks/activateVersion'
export const UPDATE_PLAYBOOK_NAME = 'playbooks/updateName'
export const SET_RTN_ORG = 'playbooks/setRTNOrg'
export const SET_RTN_PROMPT = 'playbooks/setRTNPrompt'
export const SET_RTN_MODEL_OPTIONS = 'playbooks/setRTNModelOptions'
export const SET_RTN_METRICS = 'playbooks/setRTNMetrics'
export const SET_RTN_BIT_FLOW = 'playbooks/setRTNBitFlow'
export const SET_RTN_BIT_FLOW_VERSIONS = 'playbooks/setRTNBitFlowVersions'
export const SET_RTN_ORG_DEFAULT_FLOW = 'playbooks/setRTNOrgDefaultFlow'
export const SET_RTN_ORG_DEFAULT_FLOW_VERSIONS = 'playbooks/setRTNOrgDefaultFlowVersions'
export const SET_RTN_ORG_DEFAULT_VIEWED_VERSION = 'playbooks/setRTNOrgDefaultViewedVersion'
export const SET_RTN_ORG_DEFAULT_PROMPT = 'playbooks/setRTNOrgDefaultPrompt'
export const SET_RTN_ORG_DEFAULT_VIEWED_PROMPT = 'playbooks/setRTNOrgDefaultViewedPrompt'
export const SET_RTN_ORG_DEFAULT_VIEWED_PROMPT_FAILED =
  'playbooks/setRTNOrgDefaultViewedPromptFailed'
export const SET_RTN_ORG_DEFAULT_REMOVAL_PREVIEW = 'playbooks/setRTNOrgDefaultRemovalPreview'
export const SET_RTN_FIELD_NAMES = 'playbooks/setRTNFieldNames'
export const SET_RTN_FIELD_PROMPTS = 'playbooks/setRTNFieldPrompts'
export const SET_RTN_RECENT_CALLS = 'playbooks/setRTNRecentCalls'
export const SET_CURRENT = 'playbooks/setCurrent'

export const CREATE_ENTRY = 'playbooks/createEntry'
export const UPDATE_ENTRY = 'playbooks/updateEntry'
export const DELETE_ENTRY = 'playbooks/deleteEntry'
export const REORDER_ENTRY = 'playbooks/reorderEntry'
export const LOCK_ENTRY = 'playbooks/lockEntry'
export const WIN_ENTRY = 'playbooks/winEntry'
export const REORDER_MOVE_ENTRY = 'playbooks/reorderAndMoveEntry'
export const UPDATE_CATEGORY_NAME = 'playbooks/updateCategoryName'
export const CREATE_CHECKLIST_CATEGORY = 'playbooks/createChecklistCategory'
export const DELETE_CHECKLIST_CATEGORY = 'playbooks/deleteChecklistCategory'
export const UPDATE_CHECKLIST_CATEGORY_NAME = 'playbooks/updateChecklistCategoryName'
export const REORDER_CHECKLIST_CATEGORIES = 'playbooks/reorderChecklistCategories'
export const MOVE_CHECKLIST_ITEM = 'playbooks/moveChecklistItem'

// Action Creators
export const setLoading = (payload) => ({ type: SET_LOADING, payload })
export const setPlaybook = (payload) => ({ type: SET_PLAYBOOK, payload })
export const setPlaybookWarnings = (payload) => ({ type: SET_PLAYBOOK_WARNINGS, payload })
export const setPlaybookSectionWarnings = (accessor) => (payload) => ({ type: SET_PLAYBOOK_SECTION_WARNINGS,  payload,  accessor }) /* prettier-ignore */
export const setPlaybookEntryWarnings = (accessor) => (payload) => ({ type: SET_PLAYBOOK_ENTRY_WARNINGS, payload, accessor }) /* prettier-ignore */
export const setChecklistVariations = (payload) => ({ type: SET_CHECKLIST_VARIATIONS, payload }) /* prettier-ignore */
export const setNovelChecklistItems = (payload) => ({ type: SET_NOVEL_CHECKLIST_ITEMS, payload }) /* prettier-ignore */
export const setCurrent = (payload) => ({ type: SET_CURRENT, payload })
export const toggleNovelChecklistItems = (payload) => ({
  type: TOGGLE_NOVEL_CHECKLIST_VISIBLE,
  payload,
})
export const setChecklistItemVariations = (payload, checklistItemId) => ({ type: SET_CHECKLIST_ITEM_VARIATIONS, checklistItemId, payload }) /* prettier-ignore */
export const setValidationError = (payload) => ({ type: SET_VALIDATION_ERROR, payload })
export const clearValidationError = () => ({ type: CLEAR_VALIDATION_ERROR })
export const setPlaybookVersions = (payload) => ({ type: SET_PLAYBOOK_VERSIONS, payload })
export const activatePlaybookVersion = () => ({ type: ACTIVATE_PLAYBOOK_VERSION })
export const updatePlaybookName = (payload) => ({ type: UPDATE_PLAYBOOK_NAME, payload, sanitizeType: 'playbook' }) /* prettier-ignore */
export const setRTNOrg = (payload) => ({ type: SET_RTN_ORG, payload })
export const setRTNPrompt = (payload) => ({ type: SET_RTN_PROMPT, payload })
export const setRTNModelOptions = (payload) => ({ type: SET_RTN_MODEL_OPTIONS, payload })
export const setRTNMetrics = (payload) => ({ type: SET_RTN_METRICS, payload })
export const setRTNBitFlow = (payload) => ({ type: SET_RTN_BIT_FLOW, payload })
export const setRTNBitFlowVersions = (payload) => ({ type: SET_RTN_BIT_FLOW_VERSIONS, payload }) /* prettier-ignore */
export const setRTNOrgDefaultFlow = (payload) => ({ type: SET_RTN_ORG_DEFAULT_FLOW, payload })
export const setRTNOrgDefaultFlowVersions = (payload) => ({ type: SET_RTN_ORG_DEFAULT_FLOW_VERSIONS, payload }) /* prettier-ignore */
export const setRTNOrgDefaultViewedVersion = (payload) => ({ type: SET_RTN_ORG_DEFAULT_VIEWED_VERSION, payload }) /* prettier-ignore */
export const setRTNOrgDefaultPrompt = (payload) => ({ type: SET_RTN_ORG_DEFAULT_PROMPT, payload }) /* prettier-ignore */
export const setRTNOrgDefaultViewedPrompt = (payload) => ({ type: SET_RTN_ORG_DEFAULT_VIEWED_PROMPT, payload }) /* prettier-ignore */
export const setRTNOrgDefaultViewedPromptFailed = (payload) => ({ type: SET_RTN_ORG_DEFAULT_VIEWED_PROMPT_FAILED, payload }) /* prettier-ignore */
export const setRTNOrgDefaultRemovalPreview = (payload) => ({ type: SET_RTN_ORG_DEFAULT_REMOVAL_PREVIEW, payload }) /* prettier-ignore */
export const setRTNFieldNames = (payload) => ({ type: SET_RTN_FIELD_NAMES, payload })
export const setRTNRecentCalls = (payload) => ({ type: SET_RTN_RECENT_CALLS, payload })
export const setRTNFieldPrompts = (payload) => ({ type: SET_RTN_FIELD_PROMPTS, payload })

export const createEntry = (accessor) => (payload) => ({ type: CREATE_ENTRY, payload, accessor, sanitizeType: 'entry' }) /* prettier-ignore */
export const updateEntry = (accessor) => (payload) => ({ type: UPDATE_ENTRY, payload, accessor, sanitizeType: 'entry' }) /* prettier-ignore */
export const deleteEntry = (accessor) => (payload) => ({ type: DELETE_ENTRY, payload, accessor })
export const reorderEntry = (accessor) => (payload) => ({ type: REORDER_ENTRY, payload, accessor })
export const lockEntryToggle = (accessor) => (payload) => ({ type: LOCK_ENTRY, payload, accessor })
export const winEntryToggle = (accessor) => (payload) => ({ type: WIN_ENTRY, payload, accessor })
export const reorderAndMoveEntry = (accessor) => (payload) => ({ type: REORDER_MOVE_ENTRY, payload, accessor }) /* prettier-ignore */
export const updateCategoryName = (accessor) => (payload) => ({ type: UPDATE_CATEGORY_NAME, payload, accessor, sanitizeType: 'category' }) /* prettier-ignore */
export const createChecklistCategory = (payload) => ({ type: CREATE_CHECKLIST_CATEGORY, payload, sanitizeType: 'category' }) /* prettier-ignore */
export const deleteChecklistCategory = (payload) => ({ type: DELETE_CHECKLIST_CATEGORY, payload })
export const updateChecklistCategoryName = (payload) => ({ type: UPDATE_CHECKLIST_CATEGORY_NAME, payload, sanitizeType: 'category' }) /* prettier-ignore */
export const reorderChecklistCategoriesAction = (payload) => ({
  type: REORDER_CHECKLIST_CATEGORIES,
  payload,
})
export const moveChecklistItemAction = (payload) => ({ type: MOVE_CHECKLIST_ITEM, payload })

// State
export const initialState = {
  // This is the data that actually comes back from the endpoint
  playbook: {
    active: false,
    annotations: {},
    began_editing: null, // timestamp from the BE to prevent multiple people from submitting and overwriting each other's work
    body: initialPlaybookBody,
    cid: null, // playbook (config) id, a uuid
    created: '',
    current: false, // current = is latest playbook version id
    deleted: false,
    id: null, // playbook version id, a number
    name: '',
    organization_id: null,
    stats: {},
    uuid: null,
    created_by: null,
  },

  // This is other data we want to keep track of for playbook editing. Let's keep them separate.
  warnings: initialPlaybookWarningsBody,
  versions: [], // switch between playbook versions, used by Balto admins only
  dirty: false, // playbook has been edited
  scorecardAssociations: [],
  mostRecentId: null,
  validationError: {
    accessor: null,
    entry: null,
    errorMessage: null,
  },
  loading: {
    playbook: false,
    versions: false,
    savePlaybook: false,
    warnings: false,
    smartPhraseSuggestions: null,
    prompt: false,
    promptTests: false,
    rtnMetrics: false,
    rtnModelOptions: false,
    orgDefaultFlow: false,
    saveOrgDefaultFlow: false,
    rtnFieldNames: false,
    rtnBitFlowVersions: false,
    rtnOrgDefaultFlowVersions: false,
    rtnOrgDefaultViewedPrompt: false,
    rtnRecentCalls: false,
  },
  checklistVariations: {},
  checklistItemVariations: {},
  listIDsInDB: {
    checklist: [],
    classified_postcall: [],
    deck: [],
  },
  novelChecklistItems: [],
  novelChecklistItemsVisible: false,
  rtnOrg: null,
  rtnPrompt: null,
  rtnBitFlow: null,
  // Every saved version of the loaded flow, newest first — element 0 is the
  // active one. Lets the editor show an older version (read-only).
  rtnBitFlowVersions: [],
  rtnOrgDefaultFlow: null,
  // The org default flow's own history, newest first — the default is just the
  // flow with no playbook or call-type scope, so it versions like any other.
  rtnOrgDefaultFlowVersions: [],
  // The older default version the defaults editor is showing, or null for the
  // current one (which renders from rtnOrgDefaultFlow).
  rtnOrgDefaultViewedVersion: null,
  // The prompt record the viewed older version ran on (admins only) — kept apart
  // from rtnOrgDefaultPrompt, which a save diffs against and builds on.
  rtnOrgDefaultViewedPrompt: null,
  // Whether that prompt couldn't be read — restoring then waits, rather than
  // putting back the current prompt in its place.
  rtnOrgDefaultViewedPromptFailed: false,
  rtnOrgDefaultPrompt: null,
  rtnOrgDefaultRemovalPreview: null,
  rtnModelOptions: [],
  rtnMetrics: {},
  rtnFieldNames: [],
  // Full prompt records for a loaded flow's extraction fields, keyed by
  // prompt_uuid. Lets the editor show each individual-execution field's model
  // and version the right prompt on save. Only populated for org 1 (admins).
  rtnFieldPrompts: {},
  // The loaded configuration's most recent calls, newest first — what the test
  // drawer offers to run against so a call id doesn't have to be hunted down —
  // and which configuration they were fetched for, so a response that arrives
  // after the user has moved on isn't read as the current one's.
  rtnRecentCalls: [],
  rtnRecentCallsScope: null,
}

// Reducer
const playbookReducer = (state = initialState, action) => {
  return produce(state, (newState) => {
    const { payload, accessor } = action

    switch (action.type) {
      case SET_PLAYBOOK:
        newState.dirty = false
        newState.playbook = payload
        newState.novelChecklistItemsVisible = false
        newState.listIDsInDB = {
          checklist: payload?.body?.checklist?.order,
          classified_postcall: getAllCategoryIDs(payload.body.classified_postcall.entries),
          deck: getAllCategoryIDs(payload.body.deck.entries),
        }
        break
      case SET_PLAYBOOK_WARNINGS:
        newState.warnings = payload
        break
      case SET_PLAYBOOK_SECTION_WARNINGS:
        newState.warnings[accessor] = payload
        break
      case SET_PLAYBOOK_ENTRY_WARNINGS:
        newState.warnings[accessor][payload.entryId] = payload.entryWarnings
        break
      case SET_NOVEL_CHECKLIST_ITEMS:
        newState.novelChecklistItems = payload
        break
      case TOGGLE_NOVEL_CHECKLIST_VISIBLE:
        newState.novelChecklistItemsVisible = payload
        break
      case SET_CHECKLIST_VARIATIONS:
        addChecklistVariations(newState, payload)
        break
      case SET_CHECKLIST_ITEM_VARIATIONS:
        addChecklistItemVariations(newState, payload, action.checklistItemId)
        break
      case SET_VALIDATION_ERROR:
        newState.validationError = action.payload
        break
      case CLEAR_VALIDATION_ERROR:
        newState.validationError = initialState.validationError
        break
      case SET_PLAYBOOK_VERSIONS:
        newState.versions = payload
        break
      case ACTIVATE_PLAYBOOK_VERSION:
        newState.playbook.active = true
        break
      case UPDATE_PLAYBOOK_NAME:
        newState.dirty = true
        newState.playbook.name = payload.name
        break
      case UPDATE_CATEGORY_NAME:
        newState.dirty = true
        newState.playbook.body[accessor].entries[payload.categoryId].name = payload.name
        break
      case CREATE_ENTRY:
        add(newState, payload, accessor)
        break
      case UPDATE_ENTRY:
        edit(newState, payload, accessor)
        break
      case DELETE_ENTRY:
        remove(newState, state, payload, accessor)
        break
      case LOCK_ENTRY:
        lock(newState, state, payload, accessor)
        break
      case WIN_ENTRY:
        win(newState, state, payload, accessor)
        break
      case REORDER_ENTRY:
        reorder(newState, payload, accessor)
        break
      case REORDER_MOVE_ENTRY:
        reorderAndMove(newState, payload, accessor)
        break
      case CREATE_CHECKLIST_CATEGORY:
        addChecklistCategory(newState, payload)
        break
      case DELETE_CHECKLIST_CATEGORY:
        removeChecklistCategory(newState, state, payload)
        break
      case UPDATE_CHECKLIST_CATEGORY_NAME:
        renameChecklistCategory(newState, payload)
        break
      case REORDER_CHECKLIST_CATEGORIES:
        reorderChecklistCategories(newState, payload)
        break
      case MOVE_CHECKLIST_ITEM:
        moveChecklistItem(newState, payload)
        break
      // TODO: All of this belongs somewhere else
      case SET_RTN_ORG:
        newState.rtnOrg = payload
        break
      case SET_RTN_PROMPT:
        newState.rtnPrompt = payload
        break
      case SET_RTN_BIT_FLOW:
        newState.rtnBitFlow = payload
        break
      case SET_RTN_BIT_FLOW_VERSIONS:
        newState.rtnBitFlowVersions = payload
        break
      case SET_RTN_ORG_DEFAULT_FLOW:
        newState.rtnOrgDefaultFlow = payload
        break
      case SET_RTN_ORG_DEFAULT_FLOW_VERSIONS:
        newState.rtnOrgDefaultFlowVersions = payload
        break
      case SET_RTN_ORG_DEFAULT_VIEWED_VERSION:
        newState.rtnOrgDefaultViewedVersion = payload
        // A viewed prompt belongs to the version it was loaded for.
        newState.rtnOrgDefaultViewedPrompt = null
        newState.rtnOrgDefaultViewedPromptFailed = false
        break
      case SET_RTN_ORG_DEFAULT_VIEWED_PROMPT:
        newState.rtnOrgDefaultViewedPrompt = payload
        break
      case SET_RTN_ORG_DEFAULT_VIEWED_PROMPT_FAILED:
        newState.rtnOrgDefaultViewedPromptFailed = payload
        break
      case SET_RTN_ORG_DEFAULT_PROMPT:
        newState.rtnOrgDefaultPrompt = payload
        break
      case SET_RTN_ORG_DEFAULT_REMOVAL_PREVIEW:
        newState.rtnOrgDefaultRemovalPreview = payload
        break
      case SET_RTN_FIELD_NAMES:
        newState.rtnFieldNames = payload
        break
      case SET_RTN_FIELD_PROMPTS:
        newState.rtnFieldPrompts = payload
        break
      case SET_RTN_RECENT_CALLS:
        newState.rtnRecentCalls = payload.calls
        newState.rtnRecentCallsScope = payload.scope
        break
      case SET_RTN_MODEL_OPTIONS:
        newState.rtnModelOptions = payload
        break
      case SET_RTN_METRICS:
        newState.rtnMetrics = payload
        break
      case SET_LOADING:
        newState.loading = { ...newState.loading, ...payload }
        break
      case SET_CURRENT:
        newState.playbook.current = payload
        break
      default:
        break
    }
  })
}

export default playbookReducer
